import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import aa from "search-insights";
import { v4 as uuidv4 } from "uuid";

import { useAuthContext } from "~/contexts/auth";
import appRoutes from "~/utils/app-routes";

import useSubscriptions from "./use-subscriptions";

type Props = {
  token?: string;
  categoryId?: string;
};

//This hook is used in menu, search page and product list page and is used to handle the algolia user token which allows personalization.
export function useUserTokenAlgolia(props: Props) {
  const router = useRouter();
  const { user, isAuthenticated } = useAuthContext();
  const { getUserSubscriptionValueByBackendId } = useSubscriptions();
  const [hasToken, setHasToken] = useState(false);

  const isLogged = !!user && isAuthenticated;
  const personalizationProfiling = getUserSubscriptionValueByBackendId("ProfilingOptIn");

  useEffect(() => {
    if (!props.token && (router.asPath.startsWith(appRoutes.CATEGORY) || router.asPath.startsWith(appRoutes.SEARCH))) {
      return;
    }

    if (isLogged && personalizationProfiling) {
      aa("setUserToken", `${user.ID}`);
      setHasToken(true);
    }

    if (!isLogged || !personalizationProfiling) {
      if (props.token && hasToken) {
        props.token = undefined;
      }
      const currentAnonymousUserToken = props.token || `anonymous-${uuidv4()}`;
      aa("setUserToken", currentAnonymousUserToken);
      setHasToken(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged, personalizationProfiling, props.categoryId]);

  return null;
}
